export default "__VITE_ASSET__BFgwuydY__"